
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "efaeefdd-646a-4a3b-872f-a12557be2235"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/vercel/path0/node_modules/@nuxt-themes/docus/app.config.ts"
import cfg1 from "/vercel/path0/node_modules/@nuxt-themes/typography/app.config.ts"
import cfg2 from "/vercel/path0/node_modules/@nuxt-themes/elements/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, cfg1, cfg2, inlineConfig)
